const url = {
    WEB_URL: "https://www.instabuild.com",
    // BASE_URL : "https://vnb.awarno.com/api/admin"
    BASE_URL : "https://www.backend.visualizenbuild.com/api/admin",
    // BASE_URL : "http://127.0.0.1:1080/api/admin",
    WEB_URL : "https://www.buy.visualizenbuild.com",
}
module.exports = url